import useStore from "@App/store";
import {GET_VEHICLETREE} from "@App/graphql/queries/getVehicletree";
import {useQuery} from "@apollo/client";

export const useVehicletree = () => {

    const state = useStore()


    const {loading, data, error} = useQuery(GET_VEHICLETREE, {
        variables: {
            ...state.filters.brandFilter.id && {brandId: +state.filters.brandFilter.id}, // use +brand.id to convert string to number
            ...state.filters.brandFilter.id != '0' && {includeGenerations:  true},
            ...state.filters.brandFilter.id == '0' && {includeGenerations:  false},
            ...state.filters.generationFilter.id != 0 && {includeMotorizations: true},
            ...state.filters.generationFilter.id == 0 && {includeMotorizations: false},
        },

    })

    return {
        loading: loading,
        error: error,
        brands: data ? data.brands : null,
        generations: data && state.filters.brandFilter ? data.brands[0].generations : null,
        motorizations: data && state.filters.brandFilter && state.filters.generationFilter && state.filters.generationFilter.id != 0 && data.brands[0].generations ? data.brands[0].generations[0]?.motorizations : null,
    }
}



